<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    refs: string[];
    refClass?: string;
  }>(),
  {
    refClass: "",
  },
);
</script>

<template>
  <div
    v-for="(refNumber, index) of props.refs"
    :key="refNumber"
    :class="refClass"
    class="d-flex align-center ref-number"
  >
    <span v-if="index === 0"> # </span>

    <span v-clipboard.uncolored="refNumber" class="font-size-14" data-qa="ref-number" v-bind="props">
      {{ refNumber }}
    </span>

    <span v-if="index !== props.refs.length - 1">&nbsp;/&nbsp;</span>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.ref-number {
  span {
    transition: all ease-in-out 200ms;
    cursor: pointer;
  }

  &:hover {
    span {
      color: $primary !important;
    }
  }
}
</style>
